var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddProjectIcon = function SvgAddProjectIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#050d1e;}.b{fill:none;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14,
    height: 24,
    transform: "translate(56 346.846)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 -173)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30,
    height: 30,
    transform: "translate(-54 173)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-102 -170.846)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.61,5.687h-4.2a.247.247,0,0,1-.247-.247v-4.2a1.236,1.236,0,0,0-2.473,0v4.2a.247.247,0,0,1-.247.247h-4.2a1.236,1.236,0,0,0,0,2.473h4.2a.247.247,0,0,1,.247.247v4.2a1.236,1.236,0,1,0,2.473,0v-4.2a.247.247,0,0,1,.247-.247h4.2a1.236,1.236,0,1,0,0-2.473Zm0,0",
    transform: "translate(56 352)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddProjectIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AddProjectIcon.f586e9619e1e9a9187afd1400f4c2003.svg";